//index.js
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ResetPasswordForm from './ResetPasswordForm';

export { ForgotPasswordForm, LoginForm, RegisterForm, ResetPasswordForm };
